import { createFileRoute } from '@tanstack/react-router';
import { SSensorNew } from '@/screens/SSensorNew/SSensorNew';

export const Route = createFileRoute('/$orgId/sensors/new')({
  component: SSensorNew,
});
